import type { RouteRecordRaw } from 'vue-router';

export const chatRoutes: Array<RouteRecordRaw> = [
  {
    path: '/chat',
    name: 'chat',
    redirect: '/chat/test',
    component: () => import('pages/micros/chat/TestChat.vue'),
    meta: {
      title: 'Chats',
      requiresAuth: true,
    },
    children: [
      {
        path: 'test',
        name: 'chatTest',
        component: () => import('pages/micros/chat/TestChat.vue'),
        meta: {
          title: 'Chat Testing Page',
          requiresAuth: true,
        },
      },
    ],
  },
];
